import * as React from 'react';

import {
  DescriptionPage_MarketingSource as MarketingSource,
  Campaign_ProductType as ProductType,
} from '__generated__/graphql-types';

import CampaignModulesDataProviderForPaidMediaXdp from 'bundles/campaigns/providers/CampaignModulesDataProviderForPaidMediaXdp';
import { savedProductTypes } from 'bundles/unified-description-page-common/constants';
import CoursePriceProvider from 'bundles/unified-description-page-common/providers/CoursePriceProvider';
import { CourseArticlesRecsDataProvider } from 'bundles/unified-description-page-common/providers/consumer/ArticlesRecommendationsDataProvider';
import { CourseCourseraPlusOwnershipDataProvider } from 'bundles/unified-description-page-common/providers/consumer/CourseraPlusOwnershipDataProvider';
import CourseraPlusSavedProductDataProvider from 'bundles/unified-description-page-common/providers/consumer/CourseraPlusSavedProductDataProvider';
import ConsumerBffCourseMarketingDataProvider from 'bundles/unified-description-page-common/providers/consumer/bff/ConsumerBffCourseMarketingDataProvider';
import { ConsumerDegreesProductCollectionsDataProvider } from 'bundles/unified-description-page-common/providers/course/CourseDegreesCollectionsDataProvider';
import UserDataProvider from 'bundles/unified-description-page-common/providers/user/UserDataProvider';

type Props = {
  children: React.ReactNode;
};

const ConsumerCoursePaidMediaPageDataProvider = ({ children }: Props) => {
  return (
    <ConsumerBffCourseMarketingDataProvider marketingSource={MarketingSource.PaidMedia}>
      <CampaignModulesDataProviderForPaidMediaXdp productType={ProductType.Course}>
        <CourseCourseraPlusOwnershipDataProvider>
          <CourseraPlusSavedProductDataProvider savedProductType={savedProductTypes.COURSE}>
            <UserDataProvider includeOpenCourseMemberships>
              <ConsumerDegreesProductCollectionsDataProvider>
                <CourseArticlesRecsDataProvider>
                  <CoursePriceProvider>{children}</CoursePriceProvider>
                </CourseArticlesRecsDataProvider>
              </ConsumerDegreesProductCollectionsDataProvider>
            </UserDataProvider>
          </CourseraPlusSavedProductDataProvider>
        </CourseCourseraPlusOwnershipDataProvider>
      </CampaignModulesDataProviderForPaidMediaXdp>
    </ConsumerBffCourseMarketingDataProvider>
  );
};

export default ConsumerCoursePaidMediaPageDataProvider;
